/**
 * 限制很多...
 */

import { Table, TableColumn } from "kpc/components/table";
import { Pagination } from "kpc/components/pagination";

import * as _ from "lodash";

import { Vue, Component, Watch, Prop, PropSync } from "vue-property-decorator";

const rowCheckModes = {
    default: "default",
    single: "single"
};

@Component({
    components: {
        Table,
        TableColumn,
        Pagination
    }
})
export default class TableWithPagination extends Vue {
    @Prop({
        default: true
    })
    cloneData!: boolean

    @Prop({
        required: true,
        default: () => []
    })
    data!: any[];

    @Prop({
        required: false,
        default: "checkbox"
    })
    checkType!: any;

    @Prop({
        required: false,
        default: () => {}
    })
    group!: Object;

    @Prop({
        required: true,
        default: (item: any) => item.Id
    })
    rowKey!: Function;

    @Prop({
        required: false,
        default: rowCheckModes.single
    })
    rowCheckMode!: string


    @Prop({
        required: false,
        default: "border"
    })
    type!: string

    @PropSync("checkedKeys", {
        required: false,
        default: () => []
    })
    checkedKeysInner!: any[];

    @PropSync("checkedKey", {
        required: false,
        default: ''
    }) checkedKeyInner!: string


    searchQuery = "";
    listSrc: any[] = [];
    listSrcFiltered: any[] = [];
    list: any[] = [];

    // checkedKeys: any[] = []

    sort: any = {};

    innerGroup: any = {};

    page = {
        total: 0,
        current: 1,
        limit: 20,
        limits: [20, 50, 100]
    };

    @Watch("data", {
        // deep: true
    })
    dataWatcher() {
        // console.log('data, update')
        this._doUpdateSrcData(this.data);
    }

    @Watch("group", {
        deep: true
    })
    groupWatcher() {
        if (!_.isEqual(this.group, this.innerGroup)) {
            this._doGroup(this.$refs.table, this.group);
        }
    }

    @Watch("innerGroup", {
        deep: true
    })
    innerGroupWatcher() {
        if (!_.isEqual(this.group, this.innerGroup)) {
            this.$emit("update:group", this.innerGroup);
        }
    }

    // @Watch('checkedKeys', {
    //     deep: true,
    // })
    // checkedKeysWatcher() {
    //     this._emitCheckedKeys();
    // }

    scrollToRowByKey(key: any) {
        (this.$refs.table as any).scrollToRowByKey(key);
    }

    _doUpdateSrcData(data: any) {
        this.listSrc = this.cloneData ? _.cloneDeep(data) : data;
        this.listSrcFiltered = [];
        this.list = [];
        this.checkedKeysInner = [];
        this._doGroup(this.$refs.table, this.group);
    }

    _doGroup(c: any, group: any) {
        let listSrc = _.clone(this.listSrc); //_.cloneDeep(this.listSrc);
        if (!_.isEmpty(group)) {
            listSrc = _.filter(listSrc, item => {
                let isOk = true;
                _.forEach(group, (v, k) => {
                    if (
                        v !== "" &&
                        v !== null &&
                        v !== undefined &&
                        item[k] !== v
                    ) {
                        isOk = false;
                    }
                });
                return isOk;
            });
        }
        this.listSrcFiltered = listSrc;
        this.innerGroup = group;

        this._doSort(this.$refs.table, this.sort);
    }

    _doSort(c: any, sort: any) {
        let listSrcFiltered = _.clone(this.listSrcFiltered); //_.cloneDeep(this.listSrcFiltered);
        if (sort && sort.key && sort.type) {
            // let column = _.get(c._columns, sort.key)
            // let valueType = _.get(column, 'attributes.valueType');

            let op = sort.type === 'desc' ? -1 : 1
            listSrcFiltered.sort((a, b) => {

                let aValue = a[sort.key];
                let bValue = b[sort.key];

                if (aValue === null || aValue === undefined) {
                    return op;
                }
                if (bValue === null || bValue === undefined) {
                    return op * -1;
                }
                return (aValue > bValue ? 1 : -1) * op;

                // return sort.type === 'desc' ?
                //     (a[sort.key] > b[sort.key] ? -1 : 1) :
                //     (a[sort.key] > b[sort.key] ? 1 : -1);
            });
        }
        this.sort = sort;
        this.listSrcFiltered = listSrcFiltered;
        this._doPage();
    }

    _doPage() {
        let page = _.cloneDeep(this.page);
        page.total = this.listSrcFiltered.length;
        let start = (page.current - 1) * page.limit;
        if (start > page.total) {
            page.current = 1;
            start = 0;
        }
        let end = start + page.limit;
        this.page = page;
        this.list = this.listSrcFiltered.slice(start, end);
    }

    _handlePageChange(pageConfig: any) {
        this.page.current = pageConfig.current;
        this.page.limit = pageConfig.limit;
        this._doPage();
        (this.$refs.table as any).scrollToRowByIndex(0);
    }

    _emitCheckedKey(c: any, key: string) {
        this.checkedKeyInner = key;
        this.$emit("update:checkedKey", key);
    }
    _emitCheckedKeys(c: any, keys: any[]) {
        this.checkedKeysInner = keys;
        this.$emit("update:checkedKeys", keys);
        this.$emit("checkedKeysChange", keys);
    }

    _onClickRow(data: any, index: any, key: any) {
        if (this.checkType === "checkbox") {
            let checkedKeys = _.cloneDeep(this.checkedKeysInner);
            if (this.rowCheckMode === rowCheckModes.single) {
                if (checkedKeys.length === 1 && checkedKeys[0] === key) {
                    // 如果只选中了一行，再次点击当前行，则取消选中
                    checkedKeys = [];
                } else {
                    // 否则只选中当前行
                    checkedKeys = [key];
                }
            } else {
                if (checkedKeys.indexOf(key) !== -1) {
                    _.remove(checkedKeys, item => item === key);
                } else {
                    checkedKeys.push(key);
                }
            }
            this.checkedKeysInner = checkedKeys;
        } else if (this.checkType === "radio") {
            // console.log(this.checkedKeyInner, key, 213)
            const checkedKey = this.checkedKeyInner;
            // if (checkedKeys.length === 1 && checkedKeys[0] === key) {
            //     // 如果只选中了一行，再次点击当前行，则取消选中
            //     key = [];
            // } else {
            //     // 否则只选中当前行
            //     key = [key];
            // }
            if (checkedKey === key) {
                this.checkedKeyInner = "";
            } else {
                this.checkedKeyInner = key;
            }
            // console.log(this.checkedKeyInner, checkedKey === key, 3)
        }
    }

    async created() {
        this._doUpdateSrcData(this.data);
    }

    mounted() {
        // console.log(this, 'table')
        this.$emit("mounted");
    }
}
